import { z } from 'zod';

/**
 * A relationship between two sources
 *
 * Interpret this as "left" references "right"
 */
export const SourceRelationshipSchema = z.object({
  leftSourceId: z.string(),
  rightSourceId: z.string(),
  createdAt: z.coerce.date(),
});
